import { render, staticRenderFns } from "./ThirdPartyCard.vue?vue&type=template&id=3d5debd9"
import script from "./ThirdPartyCard.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyCard.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyCard.vue?vue&type=style&index=0&id=3d5debd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports